import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Filter } from '../../../models/filter-models';
import { TieringMode } from '../../../models/enums';
import { FilterService } from '../../../services/filter.service';
import { FilterTitleComponent } from '../../../common/filter-title/filter-title.component';
import { CurrencyTierService } from '../../../services/tiering/currency-tier.service';
import { BaseComponent } from '../../../common/base.component';
import { SelectComponent, SelectOptionComponent } from '../../../common/select/select.component';
import { Economy } from '../../../models/economy-models';
import { CustomCurrencyTieringModeDialogComponent } from '../../../custom-currency-tiering-mode-dialog/custom-currency-tiering-mode-dialog.component';
import { CustomDivCardTieringModeDialogComponent } from '../../../custom-div-card-tiering-mode-dialog/custom-div-card-tiering-mode-dialog.component';
import { PresetsService } from '../../../services/presets.service';

@Component({
  selector: 'app-currency-general-filters',
  imports: [FormsModule, FilterTitleComponent, SelectComponent, SelectOptionComponent, CustomCurrencyTieringModeDialogComponent, CustomDivCardTieringModeDialogComponent],
  templateUrl: './currency-general-filters.component.html',
  styleUrl: './currency-general-filters.component.scss'
})
export class CurrencyGeneralFiltersComponent extends BaseComponent {
  @Input({ required: true }) filter!: Filter;

  Economy = Economy;
  showCustomTieringDialog = false;
  showCustomDivCardTieringDialog = false;

  constructor(
    private filterService: FilterService,
    private currencyTierService: CurrencyTierService,
    private presetsService: PresetsService,
  ) {
    super();
  }

  updateFilter() {
    this.filterService.updateFilter();
  }

  updateEconomy() {
    if (this.filter.ssf || this.filter.ruthless) {
      this.filter.economy = Economy.Fixed;
    }
    this.filterService.updateAllEconomyTiers();
    this.filterService.updateFilter(true);
  }

  toggleSsf() {
    this.presetsService.toggleSsf();
    if (this.filter.ssf || this.filter.ruthless) {
      this.filter.economy = Economy.Fixed;
    } else if (this.filter.hardcore) {
      this.filter.economy = this.filter.league ? Economy.LeagueHardcore : Economy.StandardHardcore;
    } else {
      this.filter.economy = this.filter.league ? Economy.League : Economy.Standard;
    }
    this.filterService.updateAllEconomyTiers();
    this.filterService.updateFilter(true);
  }

  currencyTieringModeChanged(mode: TieringMode) {
    this.currencyTierService.setTieringMode(mode, this.filter);
    this.filterService.updateFilter(true);
  }

  divCardTieringModeChanged(mode: TieringMode) {
    this.currencyTierService.setDivCardTieringMode(mode, this.filter);
    this.filterService.updateFilter(true);
  }

  openCustomTieringDialog() {
    this.showCustomTieringDialog = true;
  }

  closeCustomTieringDialog() {
    this.showCustomTieringDialog = false;
    this.updateFilter();
  }

  openCustomDivCardTieringDialog() {
    this.showCustomDivCardTieringDialog = true;
  }

  closeCustomDivCardTieringDialog() {
    this.showCustomDivCardTieringDialog = false;
    this.updateFilter();
  }
}
